import { handleRequest } from '_services';

export const diaryService = {
    saveDiary
};

async function saveDiary(ptno, diaryEntry, category, assignTo) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ptno, diaryEntry, category, assignTo })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/diary/save', requestOptions, true);
}